import {
  BlockResource,
  BlockResourceGetWidgetIntegrations,
} from '../../resource/BlockResource/types';
import {
  PageResource,
  PageResourceAddWidgetIntegration,
  PageResourceRemoveWidgetIntegration,
} from '../../resource/PageResource/types';
import { ResourceApi } from '../../resource/Resource';
import { BLOCK, COURSE, PAGE } from '../resourceNames';
import { Dispatch } from '../thunk';
import { ActionTypes } from './actions';
import {
  AddWidgetIntegrationPayload,
  RemoveWidgetIntegrationPayload,
} from './state';
import './injectReducers';
import { ReduxState } from '../state';
import { selectCurrentCoursePath } from '../Courses/selectors';
import {
  CourseResource,
  CourseResourceGetEnabledWidgetIntegrationProviders,
} from '../../resource/CourseResource/types';

export const getBlockWidgetIntegrations = (blockId: string) => (
  dispatch: Dispatch
): Promise<void> => {
  dispatch({
    type: ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_START,
    blockId,
  });
  return ResourceApi.read<BlockResource, BlockResourceGetWidgetIntegrations>(
    BLOCK,
    blockId,
    'getWidgetIntegrations',
    undefined
  )
    .then((response) => {
      dispatch({
        type: ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_SUCCESS,
        blockId,
        integrations: response,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_FAILED,
        blockId,
        error: 'Failed fetching this block widget integrations data.',
      });
    });
};

export const addWidgetIntegration = (payload: AddWidgetIntegrationPayload) => (
  dispatch: Dispatch
): Promise<void> => {
  const { blockID, pagePath, settings, widgetIntegrationProviderId } = payload;
  dispatch({
    type: ActionTypes.ADD_WIDGET_INTEGRATION_START,
    blockId: blockID,
  });
  return ResourceApi.update<PageResource, PageResourceAddWidgetIntegration>(
    PAGE,
    pagePath,
    'addWidgetIntegration',
    {
      blockID,
      widgetIntegrationProviderId,
      settings,
    }
  ).then(
    () => {
      dispatch({
        type: ActionTypes.ADD_WIDGET_INTEGRATION_SUCCESS,
        blockId: blockID,
      });
      // Refetch after add
      dispatch(getBlockWidgetIntegrations(blockID));
    },
    () => {
      dispatch({
        type: ActionTypes.ADD_WIDGET_INTEGRATION_FAILED,
        blockId: blockID,
        error: 'This integration has already been enabled for this widget.',
      });
    }
  );
};

export const removeBlockWidgetIntegrations = (
  payload: RemoveWidgetIntegrationPayload
) => (dispatch: Dispatch): Promise<void> => {
  const { widgetIntegrationId, pagePath, blockID } = payload;
  return ResourceApi.update<PageResource, PageResourceRemoveWidgetIntegration>(
    PAGE,
    pagePath,
    'removeWidgetIntegration',
    {
      blockID,
      widgetIntegrationId,
    }
  ).then(() => {
    dispatch({
      type: ActionTypes.REMOVE_BLOCK_WIDGET_INTEGRATIONS,
      blockId: blockID,
      widgetIntegrationId,
    });
  });
};

export const getEnabledWidgetIntegrationProviders = () => (
  dispatch: Dispatch,
  getState: () => ReduxState
): Promise<void> => {
  dispatch({
    type: ActionTypes.GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_START,
  });
  const currentCoursePath = selectCurrentCoursePath(getState());
  return ResourceApi.read<
    CourseResource,
    CourseResourceGetEnabledWidgetIntegrationProviders
  >(COURSE, currentCoursePath, 'getEnabledWidgetIntegrationProviders', {})
    .then((response) => {
      dispatch({
        type: ActionTypes.GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_SUCCESS,
        enabledWidgetIntegrationProviders: response,
        coursePath: currentCoursePath,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_FAILED,
        error: error.message,
      });
    });
};
